// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__-_n-M","amount":"Amount_amount__1ctf0","tip":"Amount_tip__FKKhu","tipHeader":"Amount_tipHeader__2uQ33","tipsWrap":"Amount_tipsWrap__2T2hR"};